import { from, of } from 'rxjs';
import { filter, mergeMap, catchError } from 'rxjs/operators';
import _ from 'lodash';
import { onServerError } from '../account/login';
import { setOrgPermissionsMissing } from '../account/role';
import { OAUTH_ERRORS } from '../../constants/constants';

//- Constants
const EMPTY_CONTENT = "0";
export const SERVER_ERROR_CODE = 500;
export const SERVICE_UNAVAILABLE_CODE = 503;
export const BAD_REQUEST_CODE = 400;
export const UNAUTHORIZED_CODE = 401;
export const FORBIDDEN_CODE = 403;
export const SERVER_ERROR = "500";
export const UNAUTHORIZED = "401";
export const FORBIDDEN = "403";

export const ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS = "ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS";
export const APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED = "APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED";
export const TOTP_CODE_REQUIRED = "TOTP_CODE_REQUIRED";
export const TOTP_CODE_INVALID = "TOTP_CODE_INVALID";

export const OAUTH_REQUEST_TYPE = "OAUTH_REQUEST_TYPE";

class ApiCallFieldsError extends Error {
    constructor(fieldsErrors, ...params) {
        super(...params);

        this.name = 'ApiCallFieldsError';
        this.fieldsErrors = fieldsErrors;
    }
}

//- Epics
export const handleApiCallEpic = (action$) => {
    return action$.pipe(
        filter(action => !_.isNil(action.meta) && action.meta.apiCall),
        mergeMap(action => {
            return from(action.payload).pipe(
                mergeMap(response => {
                    if (!response.ok) {
                        if (action.meta.type === OAUTH_REQUEST_TYPE) {
                            switch (response.status) {
                                case SERVER_ERROR_CODE:
                                    throw new Error(OAUTH_ERRORS.SERVER_ERROR);

                                case SERVICE_UNAVAILABLE_CODE:
                                    throw new Error(OAUTH_ERRORS.TEMPORARILY_UNAVAILABLE);

                                case BAD_REQUEST_CODE:
                                    throw new Error(OAUTH_ERRORS.INVALID_REQUEST);

                                default:
                                    break;
                            }

                            return response.json().then(data => {
                                throw new Error(data.error || data.message || response.statusText);
                            })

                        }

                        switch (response.status) {
                            case SERVER_ERROR_CODE:
                                throw new Error(SERVER_ERROR);

                            case UNAUTHORIZED_CODE:
                                return response.json().then(data => {
                                    if (data.error === TOTP_CODE_REQUIRED || data.error === TOTP_CODE_INVALID) {
                                        throw new Error(data.error);
                                    } else {
                                        throw new Error(UNAUTHORIZED);
                                    }
                                });

                            case FORBIDDEN_CODE:
                                return response.json().then(data => {
                                    if (data.error === ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS ||
                                        data.error === APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED) {
                                        throw new Error(data.error);
                                    } else {
                                        throw new Error(FORBIDDEN);
                                    }
                                });

                            case BAD_REQUEST_CODE:
                                return response.json().then(data => {
                                    if (data.hasOwnProperty('fieldsErrors') && data.fieldsErrors) {
                                        throw new ApiCallFieldsError(data.fieldsErrors, data.error);
                                    } else {
                                        throw new Error(data.error);
                                    }
                                });

                            default:
                                break;
                        }

                        return response.json().then(data => {
                            throw new Error(data.error || data.message || response.statusText);
                        })
                    }
                    let responseType = response.headers.get('Content-Type');
                    if (!_.isNil(responseType) && responseType.startsWith('application/json')) {
                        return from(response.json());
                    } else {
                        return from(EMPTY_CONTENT);
                    }
                }),
                mergeMap(result => {
                    return of(action.meta.onSuccess(result));
                }),
                catchError(error => {
                    if (error.message === ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS) {
                        return of(action.meta.onFail(error.message), setOrgPermissionsMissing(true));
                    }
                    if (error.message === SERVER_ERROR) {
                        return of(onServerError());
                    }
                    if (error.message === UNAUTHORIZED && action.meta.onUnauthorized) {
                        return of(action.meta.onFail(error.message), action.meta.onUnauthorized());
                    }
                    if (error.message === FORBIDDEN && action.meta.onForbidden) {
                        return of(action.meta.onForbidden());
                    }
                    if (!_.isNil(error.fieldsErrors) && action.meta.onSetFieldsErrors) {
                        return of(action.meta.onFail(error.message), action.meta.onSetFieldsErrors(error.fieldsErrors));
                    }

                    return of(
                        action.meta.onFail(error.message)
                    )
                })
            )
        })
    );
};


// WEBPACK FOOTER //
// ./src/reducers/common/handleApiCall.js